import AboutUsImage from './aboutUs.webp'
import EventsImage from './events.webp'
import MembershipsImage from './memberships.webp'

export { AboutUsImage, EventsImage, MembershipsImage }
